// import avatar from "../data/images/avatar.jpg";
// import kid1 from "../data/images/kid1.png";
// import kid2 from "../data/images/kid2.png";
// import kid3 from "../data/images/kid3.jpg";
// import kid4 from "../data/images/kid4.jpg";
// import kid5 from "../data/images/kid5.jpg";
// import kids1 from "../data/images/kids-group1.jpg";
// import kids2 from "../data/images/kids-group2.jpg";
// import kids3 from "../data/images/kids-group3.png";
// import kids4 from "../data/images/kids-group4.jpeg";
// import kids5 from "../data/images/kids-group5.jpg";
// import kids6 from "../data/images/kids-group6.jpg";
// import room1 from "../data/images/room1.jpg";
// import room2 from "../data/images/room2.jpg";
// import room3 from "../data/images/room3.jpeg";
// import room4 from "../data/images/room4.jpg";
// import room5 from "../data/images/room5.jpeg";
// import room6a from "../data/images/room6a.jpg";
// import room6b from "../data/images/room6b.jpg";
// import room6c from "../data/images/room6c.jpg";

// import {
//   Gi3dGlasses,
//   GiAudioCassette,
//   Gi3dStairs,
//   GiAcid,
//   GiAce,
//   GiAcorn,
//   GiAfrica,
//   GiAk47U,
// } from "react-icons/gi";
// import { TbMessageDots } from "react-icons/tb";
// import { GiMushroomHouse } from "react-icons/gi";

import { BiHome } from "react-icons/bi";
import { CgProfile } from "react-icons/cg";
import { SlSettings } from "react-icons/sl";
import { GrHelpBook } from "react-icons/gr";
import { PiBuildingApartment } from "react-icons/pi";
import { BiBuildingHouse } from "react-icons/bi";
import { BsHouses } from "react-icons/bs";
import { BsBuildings } from "react-icons/bs";
import { TbStairsDown } from "react-icons/tb";
import { GiTreehouse } from "react-icons/gi";
import { TfiEmail } from "react-icons/tfi";

export const publicLinks = [
  { id: 2, name: "how-it-works", target: "/#how-it-works" },
  { id: 4, name: "leases", target: "/#leases" },
  { id: 5, name: "finding-tenants", target: "/#finding-tenants" },
  { id: 6, name: "collecting-rent", target: "/#collecting-rent" },
  { id: 7, name: "faq", target: "/#faq" },
  { id: 8, name: "contact", target: "/#contact" },
];

export const privateLinks = [
  {
    id: 1,
    name: "dashboard",
    target: "/dashboard",
    icon: <BiHome />,
  },
  {
    id: 2,
    name: "profile",
    target: "/profile",
    icon: <CgProfile />,
  },
  { id: 3, name: "account", target: "/account", icon: <SlSettings /> },
  { id: 4, name: "messages", target: "/messages", icon: <TfiEmail /> },
  { id: 5, name: "help", target: "/help", icon: <GrHelpBook /> },
];

export const homeTypes = [
  {
    id: 1,
    name: "house",
    icon: <BiHome />,
  },
  {
    id: 2,
    name: "apartment",
    icon: <PiBuildingApartment />,
  },
  {
    id: 3,
    name: "condo",
    icon: <BiBuildingHouse />,
  },
  {
    id: 4,
    name: "townhouse",
    icon: <BsHouses />,
  },
  {
    id: 5,
    name: "loft",
    icon: <BsBuildings />,
  },
  {
    id: 6,
    name: "basement",
    icon: <TbStairsDown />,
  },
  {
    id: 7,
    name: "tiny house",
    icon: <BiHome />,
  },
  {
    id: 8,
    name: "other",
    icon: <GiTreehouse />,
  },
];

export const statesArray = [
  {
    id: 1,
    name: "alabama",
    abbr: "al",
  },
  {
    id: 2,
    name: "alaska",
    abbr: "ak",
  },
  {
    id: 3,
    name: "american samoa",
    abbr: "as",
  },
  {
    id: 4,
    name: "arizona",
    abbr: "az",
  },
  {
    id: 5,
    name: "arkansas",
    abbr: "Aar",
  },
  {
    id: 6,
    name: "california",
    abbr: "ca",
  },
  {
    id: 7,
    name: "colorado",
    abbr: "co",
  },
  {
    id: 8,
    name: "connecticut",
    abbr: "ct",
  },
  {
    id: 9,
    name: "delaware",
    abbr: "de",
  },
  {
    id: 10,
    name: "district of columbia",
    abbr: "dc",
  },
  {
    id: 11,
    name: "federated states of micronesia",
    abbr: "fm",
  },
  {
    id: 12,
    name: "florida",
    abbr: "fl",
  },
  {
    id: 13,
    name: "georgia",
    abbr: "ga",
  },
  {
    id: 14,
    name: "guam",
    abbr: "gu",
  },
  {
    id: 15,
    name: "hawaii",
    abbr: "hi",
  },
  {
    id: 16,
    name: "idaho",
    abbr: "id",
  },
  {
    id: 17,
    name: "illinois",
    abbr: "il",
  },
  {
    id: 18,
    name: "indiana",
    abbr: "in",
  },
  {
    id: 19,
    name: "iowa",
    abbr: "ia",
  },
  {
    id: 20,
    name: "kansas",
    abbr: "ks",
  },
  {
    id: 21,
    name: "kentucky",
    abbr: "ky",
  },
  {
    id: 22,
    name: "louisiana",
    abbr: "la",
  },
  {
    id: 23,
    name: "maine",
    abbr: "me",
  },
  {
    id: 24,
    name: "marshall islands",
    abbr: "mh",
  },
  {
    id: 25,
    name: "maryland",
    abbr: "md",
  },
  {
    id: 26,
    name: "massachusetts",
    abbr: "ma",
  },
  {
    id: 27,
    name: "michigan",
    abbr: "mi",
  },
  {
    id: 28,
    name: "minnesota",
    abbr: "mn",
  },
  {
    id: 29,
    name: "mississippi",
    abbr: "ms",
  },
  {
    id: 30,
    name: "missouri",
    abbr: "mo",
  },
  {
    id: 31,
    name: "montana",
    abbr: "mt",
  },
  {
    id: 32,
    name: "nebraska",
    abbr: "ne",
  },
  {
    id: 33,
    name: "nevada",
    abbr: "nv",
  },
  {
    id: 34,
    name: "new hampshire",
    abbr: "nh",
  },
  {
    id: 35,
    name: "new jersey",
    abbr: "nj",
  },
  {
    id: 36,
    name: "new mexico",
    abbr: "nm",
  },
  {
    id: 37,
    name: "new york",
    abbr: "ny",
  },
  {
    id: 38,
    name: "north carolina",
    abbr: "nc",
  },
  {
    id: 39,
    name: "north dakota",
    abbr: "nd",
  },
  {
    id: 40,
    name: "northern mariana islands",
    abbr: "mp",
  },
  {
    id: 41,
    name: "ohio",
    abbr: "oh",
  },
  {
    id: 42,
    name: "oklahoma",
    abbr: "ok",
  },
  {
    id: 43,
    name: "oregon",
    abbr: "or",
  },
  {
    id: 44,
    name: "palau",
    abbr: "pw",
  },
  {
    id: 45,
    name: "pennsylvania",
    abbr: "pa",
  },
  {
    id: 46,
    name: "puerto rico",
    abbr: "pr",
  },
  {
    id: 47,
    name: "rhode island",
    abbr: "ri",
  },
  {
    id: 48,
    name: "south carolina",
    abbr: "sc",
  },
  {
    id: 49,
    name: "south dakota",
    abbr: "sd",
  },
  {
    id: 50,
    name: "tennessee",
    abbr: "tn",
  },
  {
    id: 51,
    name: "texas",
    abbr: "tx",
  },
  {
    id: 52,
    name: "utah",
    abbr: "ut",
  },
  {
    id: 53,
    name: "vermont",
    abbr: "vt",
  },
  {
    id: 54,
    name: "virgin islands",
    abbr: "vi",
  },
  {
    id: 55,
    name: "virginia",
    abbr: "va",
  },
  {
    id: 56,
    name: "washington",
    abbr: "wa",
  },
  {
    id: 57,
    name: "west virginia",
    abbr: "wv",
  },
  {
    id: 58,
    name: "wisconsin",
    abbr: "wi",
  },
  {
    id: 59,
    name: "wyoming",
    abbr: "wy",
  },
];

// export const locations = [
//   {
//     id: 1,
//     city: "Atlanta",
//     state: "Georgia",
//     stateAbrv: "GA",
//   },
//   {
//     id: 2,
//     city: "Austin",
//     state: "Texas",
//     stateAbrv: "TX",
//   },
//   {
//     id: 3,
//     city: "Boston",
//     state: "Massachusetts",
//     stateAbrv: "MA",
//   },
//   {
//     id: 4,
//     city: "Chicago",
//     state: "Illinois",
//     stateAbrv: "IL",
//   },
//   {
//     id: 5,
//     city: "Denver",
//     state: "Colorado",
//     stateAbrv: "CO",
//   },
//   {
//     id: 6,
//     city: "Houston",
//     state: "Texas",
//     stateAbrv: "TX",
//   },
//   {
//     id: 7,
//     city: "Jersey City",
//     state: "New Jersey",
//     stateAbrv: "NJ",
//   },
//   {
//     id: 8,
//     city: "Los Angeles",
//     state: "California",
//     stateAbrv: "CA",
//   },
//   {
//     id: 9,
//     city: "Miami",
//     state: "Florida",
//     stateAbrv: "FL",
//   },
//   {
//     id: 10,
//     city: "New Haven",
//     state: "Connecticut",
//     stateAbrv: "CT",
//   },
//   {
//     id: 11,
//     city: "New York",
//     state: "New York",
//     stateAbrv: "NY",
//   },
//   {
//     id: 12,
//     city: "Philadelphia",
//     state: "Pennsylvania",
//     stateAbrv: "PA",
//   },
//   {
//     id: 13,
//     city: "Sacramento",
//     state: "California",
//     stateAbrv: "CA",
//   },
//   {
//     id: 14,
//     city: "San Diego",
//     state: "California",
//     stateAbrv: "CA",
//   },
//   {
//     id: 15,
//     city: "San Fransisco",
//     state: "California",
//     stateAbrv: "CA",
//   },
//   {
//     id: 16,
//     city: "Seattle",
//     state: "Washington",
//     stateAbrv: "WA",
//   },
//   {
//     id: 14,
//     city: "Washington",
//     state: "District of Columbia",
//     stateAbrv: "DC",
//   },
// ];

// export const defaultUser = {
//   id: 1,
//   firstName: "D.",
//   middleName: "William",
//   lastName: "Zero",
//   email: "william@snappily.io",
//   password: "", // added to backend
//   avatar: avatar,
//   bio: "Ex-Navy pilot looking to rent rooms to some friendly people.  I'm fairly relaxed and tend to keep a 'laissez faire' attitude towards life and property management. I hope I can expect the same from you!",
//   defaultView: "landlord", // landlord, tenant
//   subscription: "basic", // Basic, Premium, Elite, Commercial
//   accountStatus: "active",
//   identification: "",
//   isIdVerified: false,
//   isPhoneVerified: false,
// };

// export const defaultProperties = [
//   {
//     id: 1,
//     landlordId: 1,
//     street: "76 E. Pearl Street",
//     street2: "",
//     city: "New Haven",
//     state: "CT",
//     zipCode: "06513",
//     homeType: "house",
//   },
//   {
//     id: 2,
//     landlordId: 1,
//     street: "36 Central Street",
//     street2: "",
//     city: "Nashua",
//     state: "NH",
//     zipCode: "03060",
//     homeType: "townhouse",
//   },
//   {
//     id: 3,
//     landlordId: 1,
//     street: "2-10 Louisburg Sq.",
//     street2: "",
//     city: "Nashua",
//     state: "NH",
//     zipCode: "03062",
//     homeType: "condo",
//   },
// ];

// export const defaultRooms = [
//   {
//     id: 1,
//     landlordId: 1,
//     propertyId: 1,
//     propertyCity: "new haven",
//     propertyState: "CT",
//     propertyZip: "06513",
//     roomName: "room-1",
//     rent: "1150",
//     securityDep: "1150",
//     shortDesc:
//       "Great room w/ great location. Fully furnished and private bathroom.",
//     longDesc:
//       "Centrally located in downtown Boise, ID. It's just 5-minute walk to the dinner, and 3 minute walk to the town store / post office. If you're tired suburbia, come enjoy the hustle and bustle of downtown where most store stay open until 6:30pm!",

//     images: [room6a, room6b, room6c],
//     isPublished: true,
//     isFurnished: false,
//     smokingOk: false,
//     maleOnly: false,
//     femaleOnly: false,
//     catsOk: false,
//     dogsOk: false,
//     lgbtFriendly: false,
//     laundry: false,
//     wifi: false,
//     parking: false,
//     isAccessible: false,
//     available: "2025-02-01",
//   },
//   {
//     id: 2,
//     landlordId: 1,
//     propertyId: 1,
//     propertyCity: "new haven",
//     propertyState: "CT",
//     propertyZip: "06513",
//     roomName: "room-2",
//     rent: "870",
//     securityDep: "870",
//     shortDesc: "High Quality Room. No social butterflies allowed!",
//     longDesc: "There's really not much more I can say about that.",
//     images: [room2],
//     isPublished: true,
//     isFurnished: false,
//     smokingOk: false,
//     maleOnly: false,
//     femaleOnly: false,
//     catsOk: false,
//     dogsOk: false,
//     lgbtFriendly: false,
//     laundry: false,
//     wifi: false,
//     parking: false,
//     isAccessible: false,
//     available: "2025-01-01",
//   },
//   {
//     id: 3,
//     landlordId: 1,
//     propertyId: 2,
//     propertyCity: "Nashua",
//     propertyState: "NH",
//     propertyZip: "03060",
//     roomName: "room-1",
//     rent: "520",
//     securityDep: "520",
//     shortDesc:
//       "Bigger than a small closet, smaller than a large closet--it that makes an sense.",
//     longDesc:
//       "This room is absolultely perfect for a minimalist. However, if you are taller than 6-feet, I would not suggest it, as you will not be able to lay down.",
//     images: [room3],
//     isPublished: false,
//     isFurnished: false,
//     smokingOk: false,
//     maleOnly: false,
//     femaleOnly: false,
//     catsOk: false,
//     dogsOk: false,
//     lgbtFriendly: false,
//     laundry: false,
//     wifi: false,
//     parking: false,
//     isAccessible: false,
//     available: "",
//   },
//   {
//     id: 4,
//     landlordId: 1,
//     propertyId: 2,
//     propertyCity: "Nashua",
//     propertyState: "NH",
//     propertyZip: "03060",
//     roomName: "room-2",
//     rent: "800",
//     securityDep: "800",
//     shortDesc: "Large Private Room in Quiet House!",
//     longDesc:
//       "This room is clean, quiet, and best of all, it is larger.  It comes with over 5,000 sqft of privacy.  Unfortunately, the room is too large to furnish, so you'll need to handle that on your own.",
//     images: [room4],
//     isPublished: false,
//     isFurnished: false,
//     smokingOk: false,
//     maleOnly: false,
//     femaleOnly: false,
//     catsOk: false,
//     dogsOk: false,
//     lgbtFriendly: false,
//     laundry: false,
//     wifi: false,
//     parking: false,
//     isAccessible: false,
//     available: "",
//   },
//   {
//     id: 5,
//     landlordId: 1,
//     propertyId: 3,
//     propertyCity: "Nashua",
//     propertyState: "NH",
//     propertyZip: "03062",
//     roomName: "room-1",
//     rent: "900",
//     securityDep: "900",
//     shortDesc:
//       "Females only! ~ Must be willing to share a bathroom with 7 teenage girls. (lots of hair) ~",
//     longDesc:
//       "I mean, all you need to know is that you'll be waiting a long long time to use the bathroom, and that the drains are often clogged with hair.",
//     images: [room5],
//     isPublished: false,
//     isFurnished: false,
//     smokingOk: false,
//     maleOnly: false,
//     femaleOnly: false,
//     catsOk: false,
//     dogsOk: false,
//     lgbtFriendly: false,
//     laundry: false,
//     wifi: false,
//     parking: false,
//     isAccessible: false,
//     available: "",
//   },
//   {
//     id: 6,
//     landlordId: 1,
//     propertyId: 3,
//     propertyCity: "Nashua",
//     propertyState: "NH",
//     propertyZip: "03062",
//     roomName: "room-2",
//     rent: "1020",
//     securityDep: "1020",
//     shortDesc:
//       "Furnished Room w/ Private Entrance, and Private Bath. All utilities included!",
//     longDesc:
//       "This room comes with a bed, two end tables, two lamps, a dressor, and tons of privacy.  You'll need to see it in person to truly appreciate.",
//     images: [],
//     isPublished: false,
//     isFurnished: false,
//     smokingOk: false,
//     maleOnly: false,
//     femaleOnly: false,
//     catsOk: false,
//     dogsOk: false,
//     lgbtFriendly: false,
//     laundry: false,
//     wifi: false,
//     parking: false,
//     isAccessible: false,
//     available: "",
//   },
//   {
//     id: 7,
//     landlordId: 1,
//     propertyId: 3,
//     propertyCity: "Nashua",
//     propertyState: "NH",
//     propertyZip: "03062",
//     roomName: "room-3",
//     rent: "650",
//     securityDep: "650",
//     shortDesc: "Room with a great view of Chinatown (No Pets allowed).",
//     longDesc:
//       "This room comes with the wonderful scents of Asia. If you are a fan of Chinese food, this is the place for you.",
//     images: [room6a, room6b, room6c],
//     isPublished: false,
//     isFurnished: false,
//     smokingOk: false,
//     maleOnly: false,
//     femaleOnly: false,
//     catsOk: false,
//     dogsOk: false,
//     lgbtFriendly: false,
//     laundry: false,
//     wifi: false,
//     parking: false,
//     isAccessible: false,
//     available: "",
//   },
//   {
//     id: 8,
//     landlordId: 1,
//     propertyId: 3,
//     propertyCity: "Nashua",
//     propertyState: "NH",
//     propertyZip: "03062",
//     roomName: "room-4",
//     rent: "760",
//     securityDep: "760",
//     shortDesc: "Furnished room with king-sized bed and private entrance.",
//     longDesc:
//       "Not only is the ebd king-sized, it is also a water bed.  (Only minor leaks here and there.)",
//     images: [room1],
//     isPublished: false,
//     isFurnished: false,
//     smokingOk: false,
//     maleOnly: false,
//     femaleOnly: false,
//     catsOk: false,
//     dogsOk: false,
//     lgbtFriendly: false,
//     laundry: false,
//     wifi: false,
//     parking: false,
//     isAccessible: false,
//     available: "",
//   },
//   {
//     id: 9,
//     landlordId: 1,
//     propertyId: 3,
//     propertyCity: "Nashua",
//     propertyState: "NH",
//     propertyZip: "03062",
//     roomName: "room-5",
//     rent: "570",
//     securityDep: "570",
//     shortDesc: "Private room, with a great view of a wall.",
//     longDesc:
//       "If you like the sounds of pigions, you will reallly enjoy this room!",
//     images: [room2],
//     isPublished: false,
//     isFurnished: false,
//     smokingOk: false,
//     maleOnly: false,
//     femaleOnly: false,
//     catsOk: false,
//     dogsOk: false,
//     lgbtFriendly: false,
//     laundry: false,
//     wifi: false,
//     parking: false,
//     isAccessible: false,
//     available: "",
//   },
//   {
//     id: 10,
//     landlordId: 1,
//     propertyId: 3,
//     propertyCity: "Nashua",
//     propertyState: "NH",
//     propertyZip: "03062",
//     roomName: "room-6",
//     rent: "1500",
//     securityDep: "1500",
//     shortDesc: "One of the biggest rooms in town.",
//     longDesc:
//       "Lots of people say they like this room because it has 7 bunkeds!",
//     images: [room3],
//     isPublished: false,
//     isFurnished: false,
//     smokingOk: false,
//     maleOnly: false,
//     femaleOnly: false,
//     catsOk: false,
//     dogsOk: false,
//     lgbtFriendly: false,
//     laundry: false,
//     wifi: false,
//     parking: false,
//     isAccessible: false,
//     available: "",
//   },
// ];

// export const defaultLeases = [
//   {
//     id: 1,
//     landlordId: 1,
//     tenantId: 10,
//     propertyId: 1,
//     roomId: 1,
//     status: "active", // created, pending, active
//     firstName: "henry",
//     middleName: "james",
//     lastName: "ashburn",
//     email: "jashburn@gmail.com",
//     phone: "",
//     payPeriod: "monthly", // weekly or monthly
//     rent: "1150",
//     securityDep: "1150",
//     leaseTerm: "12 months", // 12 months, 6 months, or 3 months
//     leaseStart: "2024-12-01",
//     leaseEnd: "2025-11-30",
//     splitsBills: true,
//     paysGas: true,
//     paysElectric: false,
//     paysWater: false,
//     paysSewer: false,
//     paysCable: false,
//     paysPhone: false,
//     paysInternet: false,
//     paysHoa: false,
//   },
//   {
//     id: 2,
//     landlordId: 1,
//     tenantId: 11,
//     propertyId: 1,
//     roomId: 2,
//     status: "created",
//     firstName: "robert",
//     middleName: "franklyn",
//     lastName: "killington",
//     email: "rfkillington@gmail.com",
//     phone: "",
//     payPeriod: "monthly",
//     rent: "950",
//     securityDep: "950",
//     leaseTerm: "3 months",
//     leaseStart: "2024-12-01",
//     leaseEnd: "TBD - 30 Days Notice",
//     splitsBills: false,
//     paysGas: true,
//     paysElectric: false,
//     paysWater: false,
//     paysSewer: false,
//     paysCable: false,
//     paysPhone: false,
//     paysInternet: false,
//     paysHoa: false,
//   },
// ];

// export const defaultTransactions = [
//   {
//     id: 1,
//     landlordId: 1,
//     tenantId: 10,
//     propertyId: 1,
//     roomId: 1,
//     createAt: "2024-10-26",
//     type: "charge", // charge, bill, payment, chore
//     name: "nov's rent", // Rent: May-2024, Late Fee: May-2024, Electric Bill: May-2024, ACH/CC/Offline Payment, Take out Trash: By May 23
//     amount: "90000",
//     dueDate: "2024-11-01",
//     choreStatus: "", // assigned, completed, incomplete
//     billId: null,
//   },
//   {
//     id: 2,
//     landlordId: 1,
//     tenantId: 10,
//     propertyId: 1,
//     roomId: 1,
//     createAt: "2024-11-01",
//     type: "payment",
//     name: "ACH",
//     amount: "90000",
//     dueDate: "",
//     choreStatus: "",
//     billId: null,
//   },
//   {
//     id: 3,
//     landlordId: 1,
//     tenantId: 10,
//     propertyId: 1,
//     roomId: 1,
//     createAt: "2024-11-15",
//     type: "chore",
//     name: "take out trash",
//     amount: "",
//     dueDate: "2024-11-18",
//     choreStatus: "assigned",
//     billId: null,
//   },
//   {
//     id: 4,
//     landlordId: 1,
//     tenantId: 10,
//     propertyId: 1,
//     roomId: 1,
//     createAt: "2024-11-18",
//     type: "chore",
//     name: "clean kitchen",
//     amount: "",
//     dueDate: "2024-11-18",
//     choreStatus: "completed",
//     billId: null,
//   },
//   {
//     id: 5,
//     landlordId: 1,
//     tenantId: 10,
//     propertyId: 1,
//     roomId: 1,
//     createAt: "2024-11-23",
//     type: "bill",
//     name: "nov's wifi",
//     amount: "2300",
//     dueDate: "2024-12-01",
//     choreStatus: "",
//     billId: 1,
//   },
//   {
//     id: 6,
//     landlordId: 1,
//     tenantId: 10,
//     propertyId: 1,
//     roomId: 1,
//     createAt: "2024-11-24",
//     type: "charge",
//     name: "dec's rent",
//     amount: "90000",
//     dueDate: "2024-12-01",
//     choreStatus: "",
//     billId: null,
//   },
//   {
//     id: 7,
//     landlordId: 1,
//     tenantId: 10,
//     propertyId: 1,
//     roomId: 1,
//     createAt: "2024-12-11",
//     type: "charge",
//     name: "late fee",
//     amount: "2500",
//     dueDate: "2024-12-01",
//     choreStatus: "",
//     billId: null,
//   },
// ];

// export const defaultArchives = [
//   {
//     id: 1,
//     landlordId: 1,
//     propertyId: 1,
//     roomId: 1,
//     tenantId: 9,
//     // propertyStreet: "123 Hobo Way",
//     // propertyStreet2: "Unit C",
//     // propertyCity: "Austin",
//     // propertyState: "TX",
//     // propertyZip: "64321",
//     // roomName: "Mikes's Room",
//     reason: "other",
//     reasonNotes:
//       "These mother fuckers were holding cock fights in the back yard.",
//     dateArchived: "2024-12-09",
//     firstName: "Bubba",
//     middleName: "James",
//     lastName: "Johnson",
//     email: "bubbajames@gmail.com",
//     phone: "301-375-5008",
//     payPeriod: "monthly", // weekly or monthly
//     rent: "950",
//     securityDep: "950",
//     leaseTerm: "12 months", // 12 months, 6 months, 3 months
//     leaseStart: "2023-12-10",
//     leaseEnd: "2024-12-09",
//     splitsBills: true,
//     paysGas: true,
//     paysElectric: false,
//     paysWater: false,
//     paysSewer: false,
//     paysCable: false,
//     paysPhone: false,
//     paysInternet: false,
//     paysHoa: false,
//   },
// ];

// export const defaultPublishedRooms = [
//   {
//     id: 1,
//     landlordId: 1,
//     propertyId: 1,
//     roomId: 1,
//     propertyCity: "new haven",
//     propertyState: "CT",
//     propertyZip: "06513",
//     roomName: "room-1",
//     rent: "800",
//     securityDep: "800",
//     shortDesc:
//       "Great room w/ great location. Fully furnished and private bathroom.",
//     longDesc:
//       "Centrally located in downtown Boise, ID. It's just 5-minute walk to the dinner, and 3 minute walk to the town store / post office. If you're tired suburbia, come enjoy the hustle and bustle of downtown where most store stay open until 6:30pm!",
//     images: [room1],
//     isFurnished: false,
//     smokingOk: false,
//     maleOnly: false,
//     femaleOnly: false,
//     catsOk: false,
//     dogsOk: false,
//     isAccessible: false,
//     available: "2025-06-01",
//   },
// ];

// export const defaultConversations = [
//   {
//     id: 1,
//     senderId: 1,
//     recipientId: 10,
//     lastMessage: "Yeah, that should cover the fee I have t",
//     viewedBySender: false,
//     viewedByRecipient: false,
//     timeOfLastMessage: "2025-01-30T22:30:18.373Z",
//     senderDeleted: false,
//     recipientDeleted: false,
//   },
//   {
//     id: 2,
//     senderId: 3,
//     recipientId: 1,
//     lastMessage: "Hey, so that's cool. But just know that t",
//     viewedBySender: false,
//     viewedByRecipient: false,
//     timeOfLastMessage: "2025-01-29T14:30:18.373Z",
//     senderDeleted: false,
//     recipientDeleted: false,
//   },
// ];

// export const defaultMessages = [
//   {
//     id: 1,
//     conversationId: 1,
//     senderId: 1,
//     recipientId: 10,
//     timeSent: "2024-12-05T14:30:18.373Z", // no longer needed
//     message: "Hey, where's the rent, Bro?", // maxLength 100 chars
//   },
//   {
//     id: 2,
//     conversationId: 1,
//     senderId: 10,
//     recipientId: 1,
//     timeSent: "2024-12-05T14:35:18.373Z",
//     message: "Sorry man, I don't have it...",
//   },
//   {
//     id: 3,
//     conversationId: 2,
//     senderId: 3,
//     recipientId: 1,
//     timeSent: "2024-12-12T20:30:57.373Z",
//     message:
//       "Hey, so I'm ready to sign the lease, I just need to find my ID. (I lost my wallent this weekend). SMH!",
//   },
//   {
//     id: 4,
//     conversationId: 2,
//     senderId: 1,
//     recipientId: 3,
//     timeSent: "2024-12-12T20:31:07.373Z",
//     message:
//       "Hey, so that's cool. But just know that this place is first-come-first-serve.  If someone else signs the lease before you, the deal will be off. FYI.",
//   },
//   {
//     id: 5,
//     conversationId: 1,
//     senderId: 10,
//     recipientId: 1,
//     timeSent: "2024-12-05T14:35:28.373Z",
//     message: "Maybe check back in a week...",
//   },
//   {
//     id: 6,
//     conversationId: 1,
//     senderId: 1,
//     recipientId: 10,
//     timeSent: "2024-12-12T14:35:27.373Z",
//     message: "It's been exactly 1-week. You have the rent?",
//   },
//   {
//     id: 7,
//     conversationId: 1,
//     senderId: 10,
//     recipientId: 1,
//     timeSent: "2024-12-12T14:45:27.373Z",
//     message:
//       "Sorry dude. Times are really tough right now. I can send you $50 if that helps?",
//   },
//   {
//     id: 8,
//     conversationId: 1,
//     senderId: 1,
//     recipientId: 10,
//     timeSent: "2024-12-12T14:45:57.373Z",
//     message:
//       "Yeah, that should cover the fee I have to pay the Sheriffs department to serve your eviction notice...",
//   },
// ];

// export const resultsData = [
//   {
//     id: 1,
//     title: "Quite Room W/ Utitlites Included",
//     image: [room6a, room6b, room6c],
//     city: "West Haven",
//     state: "CT",
//     price: 900,
//     liked: false,
//   },
//   {
//     id: 2,
//     title: "Large room w/ private bath",
//     image: [room1],
//     city: "New Haven",
//     state: "CT",
//     price: 750,
//     liked: false,
//   },
//   {
//     id: 3,
//     title: "Clean room, perfect for students!",
//     image: [room2],
//     city: "Branford",
//     state: "CT",
//     price: 850,
//     liked: false,
//   },
//   {
//     id: 4,
//     title: "Excellent room in luxury home",
//     image: [room3],
//     city: "North Haven",
//     state: "CT",
//     price: 1100,
//     liked: false,
//   },
//   {
//     id: 5,
//     title: "Beautiful room with large walk-in closet!",
//     image: [room4],
//     city: "Meriden",
//     state: "CT",
//     price: 950,
//     liked: false,
//   },
//   {
//     id: 6,
//     title: "Small room w/ great roommates!",
//     image: [false],
//     city: "East Haven",
//     state: "CT",
//     price: 750,
//     liked: false,
//   },
//   {
//     id: 7,
//     title: "Furnished room with private entrance.",
//     image: [room5],
//     city: "East Haven",
//     state: "CT",
//     price: 750,
//     liked: false,
//   },
// ];

// export const tooltipData = [
//   {
//     id: 1,
//     name: "Sun Glasses",
//     icon: <Gi3dGlasses />,
//     tip: "Sun glasses are a great way to keep the sun out of your eyes.",
//     position: "top",
//   },
//   {
//     id: 2,
//     name: "Stairs",
//     icon: <Gi3dStairs />,
//     tip: "Stairs are a common way to go from one level to another.",
//     position: "top",
//   },
//   {
//     id: 3,
//     name: "Acid",
//     icon: <GiAcid />,
//     tip: "The secret to acids is that they either donate protons, or accept electrons.",
//     position: "top",
//   },
//   {
//     id: 4,
//     name: "Ace of Spades",
//     icon: <GiAce />,
//     tip: "The hightest honor a Tuskegee Airman could receive from a white commander.",
//     position: "top",
//   },
//   {
//     id: 5,
//     name: "Acorn",
//     icon: <GiAcorn />,
//     tip: "Some acorns will grow in to mighty oak trees, while most will be eaten by squirrels.",
//     position: "top",
//   },
//   {
//     id: 6,
//     name: "Africa",
//     icon: <GiAfrica />,
//     tip: "Africa holds the world's hightest concentration of natural resources.",
//     position: "top",
//   },
//   {
//     id: 7,
//     name: "AK-47",
//     icon: <GiAk47U />,
//     tip: "A highly reliable rifle, often used for enemy surpression while executing a peel.",
//     position: "top",
//   },
//   {
//     id: 8,
//     name: "Cassette",
//     icon: <GiAudioCassette />,
//     tip: "Keep a pencil nearby, because you'll probebly need it.",
//     position: "top",
//   },
// ];
